export default __webpack_public_path__ + "static/media/NL_parcours_1_carte_2.f1534b13.png";